import React from "react";
import { useNavigate } from "react-router-dom";
import { BiPowerOff } from "react-icons/bi";
import styled from "styled-components";
import apiClient from "../utils/apiClient";
import { logoutroute } from "../utils/APIRoutes";
export default function Logout() {
  const navigate = useNavigate();
  const handleClick = async () => {
    const id = await JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCALHOST_KEY)
    )._id;
    // SECURITY: swapped `axios` for `apiClient` — /logout/:id is
    // gated by requireSelfOrAdmin(id) on the backend (the session
    // cookie must belong to that same id, or an admin). A plain axios
    // call carries no cookie, so this would 401 instead of actually
    // clearing the server-side session, even though the client would
    // still locally clear storage and navigate away as if it worked.
    const data = await apiClient.get(`${logoutroute}/${id}`);
    if (data.status === 200) {
      localStorage.clear();
      navigate("/login");
    }
  };
  return (
    <Button onClick={handleClick}>
      <BiPowerOff />
    </Button>
  );
}

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  border-radius: 0.5rem;
  background-color: #9a86f3;
  border: none;
  cursor: pointer;
  svg {
    font-size: 1.3rem;
    color: #ebe7ff;
  }
`;
